import { getString } from "../../common/common";

export const HEADING1 = "HEADING1";
export const HEADING2 = "HEADING2";
export const HEADING3 = "HEADING3";
export const HEADING4 = "HEADING4";
export const CO = "CO";
export const CO_LI1 = "CO_LI1";
export const CO_LI2 = "CO_LI2";
export const CO_LI3 = "CO_LI3";
export const CO_LI4 = "CO_LI4";
export const CO_LI5 = "CO_LI5";
export const CO_LI6 = "CO_LI6";
export const CO_LI7 = "CO_LI7";
export const CO_LI8 = "CO_LI8";
export const CO_LI9 = "CO_LI9";
export const CO_LI10 = "CO_LI10";
export const CO_LI11 = "CO_LI11";
export const CO_LI12 = "CO_LI12";
export const CO_LI13 = "CO_LI13";
export const CO_LI14 = "CO_LI14";
export const CO_LI15 = "CO_LI15";
export const CO_LI16 = "CO_LI16";
export const CO_LI17 = "CO_LI17";
export const CO_LI18 = "CO_LI18";
export const CO_LI19 = "CO_LI19";
export const CO_LI20 = "CO_LI20";
export const CO_LI21 = "CO_LI21";
export const CO_LI22 = "CO_LI22";
export const CO_LI23 = "CO_LI23";
export const CO_LI24 = "CO_LI24";
export const CO_LI25 = "CO_LI25";
export const CO_LI26 = "CO_LI26";
export const CO_LI27 = "CO_LI27";
export const CO_LI28 = "CO_LI28";
export const CO_LI29 = "CO_LI29";
export const CO_LI30 = "CO_LI30";
export const CO_LI31 = "CO_LI31";
export const CO_LI32 = "CO_LI32";
export const CO_LI33 = "CO_LI33";

export const DIV = "DIV";

export const DIV_LI1 = "DIV_LI1";
export const DIV_LI2 = "DIV_LI2";
export const DIV_LI3 = "DIV_LI3";
export const DIV_LI4 = "DIV_LI4";
export const DIV_LI5 = "DIV_LI5";
export const DIV_LI6 = "DIV_LI6";
export const DIV_LI7 = "DIV_LI7";
export const DIV_LI8 = "DIV_LI8";
export const DIV_LI9 = "DIV_LI9";
export const DIV_LI10 = "DIV_LI10";
export const DIV_LI11 = "DIV_LI11";
export const DIV_LI12 = "DIV_LI12";
export const DIV_LI13 = "DIV_LI13";
export const DIV_LI14 = "DIV_LI14";
export const DIV_LI15 = "DIV_LI15";
export const DIV_LI16 = "DIV_LI16";
export const DIV_LI17 = "DIV_LI17";
export const DIV_LI18 = "DIV_LI18";
export const DIV_LI19 = "DIV_LI19";

export const translations = {
  en: {
    [HEADING1]: "RTI Act",
    [HEADING2]: "Right to Information Act - 2005",
    [HEADING3]: "Section 4(1)(A) Section 4(1)(B)",
    [HEADING4]:
      "Measures taken under section4_1-A for indexing and catagorising of records.",
    [CO]: "Central Office",
    [CO_LI1]: "Public Relations Department",
    [CO_LI2]: "Internal Audit Department",
    [CO_LI3]: "Accounts Department",
    [CO_LI4]: "Traffic Commercial Department",
    [CO_LI5]: "Administration (HRD) Department",
    [CO_LI6]: "Administration (Recruitment) Department",
    [CO_LI7]: "Civil Engineering Department",
    [CO_LI8]: "RTI Section Central Office",
    [CO_LI9]: "Law Department (Rout)",
    [CO_LI10]: "Accident Department",
    [CO_LI11]: "Accident Relief Fund Department",
    [CO_LI12]: "Administration Department",
    [CO_LI13]: "Board Secretary Branch",
    [CO_LI14]: "Central Line checking Squad",
    [CO_LI15]: "Environment Department",
    [CO_LI16]: "Information Technology",
    [CO_LI17]: "Law Department",
    [CO_LI18]: "Marketing and Commuter Relations Department",
    [CO_LI19]: "Mechanical(Maintenance) Section",
    [CO_LI20]: "Mechanical(Maintenance)-VTMS Section",
    [CO_LI21]: "Secretarial Department",
    [CO_LI22]: "Security Department",
    [CO_LI23]: "Seniority Section",
    [CO_LI24]: "Statistical Department",
    [CO_LI25]: "Statistical Department-2",
    [CO_LI26]: "Traffic Department",
    [CO_LI27]: "Traffic AWATAR Department",
    [CO_LI28]: "Traffic Commercial Department",
    [CO_LI29]: "Traffic Commercial Department-2",
    [CO_LI30]: "All department",
    [CO_LI31]: "Labour Department",
    [CO_LI32]: "Administration (Disciplinary) Department",
    [CO_LI33]: "Stores & Purchase Department",
    [DIV]: "DIVISION",

    [DIV_LI1]: "Regional Workshop, Bangalore",
    [DIV_LI2]: "Regional Training Institute, Hassan",
    [DIV_LI3]: "Accounts Department",
    [DIV_LI4]: "Ramanagar",
    [DIV_LI5]: "Central Training Institute, Hassan",
    [DIV_LI6]: "Regional Workshop, Hassan",
    [DIV_LI7]: "Mangalore",
    [DIV_LI8]: "KBS",
    [DIV_LI9]: "Printing Press Department",
    [DIV_LI10]: "Tumkur",
    [DIV_LI11]: "Kolar",
    [DIV_LI12]: "Bangalore Central Division",
    [DIV_LI13]: "Davangere",
    [DIV_LI14]: "Chikkamagaluru",
    [DIV_LI15]: "Chamarajanagar",
    [DIV_LI16]: "Puttur",
    [DIV_LI17]: "Mandya",
    [DIV_LI18]: "Mysore (Rural)",
    [DIV_LI19]: "Mysore (Urban)",
  },
  kn: {
    [HEADING1]: "RTI Act",
    [HEADING2]: "ಮಾಹಿತಿ ಹಕ್ಕು ಕಾಯಿದೆ - 2005",
    [HEADING3]: "ವಿಭಾಗ 4(1)(A) ವಿಭಾಗ 4(1)(B)",
    [HEADING4]:
      "ದಾಖಲೆಗಳ ಸೂಚಿಕೆ ಮತ್ತು ವರ್ಗೀಕರಣಕ್ಕಾಗಿ ವಿಭಾಗ4_1-A ಅಡಿಯಲ್ಲಿ ತೆಗೆದುಕೊಳ್ಳಲಾದ ಕ್ರಮಗಳು.",
    [CO]: "ಕೇಂದ್ರ ಕಚೇರಿ",
    [CO_LI1]: "ಸಾರ್ವಜನಿಕ ಸಂಪರ್ಕ ಇಲಾಖೆ",
    [CO_LI2]: "ಆಂತರಿಕ ಲೆಕ್ಕಪರಿಶೋಧನಾ ಇಲಾಖೆ",
    [CO_LI3]: "ಲೆಕ್ಕಪತ್ರ ಇಲಾಖೆ",
    [CO_LI4]: "ಸಂಚಾರ ವಾಣಿಜ್ಯ ವಿಭಾಗ",
    [CO_LI5]: "ಆಡಳಿತ (HRD) ಇಲಾಖೆ",
    [CO_LI6]: "ಆಡಳಿತ (ನೇಮಕಾತಿ) ಇಲಾಖೆ",
    [CO_LI7]: "ಸಿವಿಲ್ ಇಂಜಿನಿಯರಿಂಗ್ ವಿಭಾಗ",
    [CO_LI8]: "RTI ವಿಭಾಗ ಕೇಂದ್ರ ಕಛೇರಿ",
    [CO_LI9]: "ಕಾನೂನು ಇಲಾಖೆ (ಮಾರ್ಗ)",
    [CO_LI10]: "ಅಪಘಾತ ವಿಭಾಗ",
    [CO_LI11]: "ಅಪಘಾತ ಪರಿಹಾರ ನಿಧಿ ಇಲಾಖೆ",
    [CO_LI12]: "ಆಡಳಿತ ಇಲಾಖೆ",
    [CO_LI13]: "ಮಂಡಳಿಯ ಕಾರ್ಯದರ್ಶಿ ಶಾಖೆ",
    [CO_LI14]: "ಸೆಂಟ್ರಲ್ ಲೈನ್ ಚೆಕ್ ಸ್ಕ್ವಾಡ್",
    [CO_LI15]: "ಪರಿಸರ ಇಲಾಖೆ",
    [CO_LI16]: "ಮಾಹಿತಿ ತಂತ್ರಜ್ಞಾನ",
    [CO_LI17]: "ಕಾನೂನು ಇಲಾಖೆ",
    [CO_LI18]: "ಮಾರ್ಕೆಟಿಂಗ್ ಮತ್ತು ಪ್ರಯಾಣಿಕ ಸಂಬಂಧಗಳ ಇಲಾಖೆ",
    [CO_LI19]: "ಮೆಕ್ಯಾನಿಕಲ್ (ನಿರ್ವಹಣೆ) ವಿಭಾಗ",
    [CO_LI20]: "ಮೆಕ್ಯಾನಿಕಲ್ (ನಿರ್ವಹಣೆ)-VTMS ವಿಭಾಗ",
    [CO_LI21]: "ಕಾರ್ಯದರ್ಶಿ ಇಲಾಖೆ",
    [CO_LI22]: "ಭದ್ರತಾ ಇಲಾಖೆ",
    [CO_LI23]: "ಹಿರಿತನ ವಿಭಾಗ",
    [CO_LI24]: "ಅಂಕಿಅಂಶ ಇಲಾಖೆ",
    [CO_LI25]: "ಅಂಕಿಅಂಶ ಇಲಾಖೆ-2",
    [CO_LI26]: "ಸಂಚಾರ ವಿಭಾಗ",
    [CO_LI27]: "ಸಂಚಾರ AWATAR ಇಲಾಖೆ",
    [CO_LI28]: "ಸಂಚಾರ ವಾಣಿಜ್ಯ ವಿಭಾಗ",
    [CO_LI29]: "ಸಂಚಾರ ವಾಣಿಜ್ಯ ವಿಭಾಗ-2",
    [CO_LI30]: "ಎಲ್ಲಾ ಇಲಾಖೆ",
    [CO_LI31]: "ಕಾರ್ಮಿಕ ಇಲಾಖೆ",
    [CO_LI32]: "ಆಡಳಿತ (ಶಿಸ್ತು) ಇಲಾಖೆ",
    [CO_LI33]: "ಅಂಗಡಿಗಳು ಮತ್ತು ಖರೀದಿ ಇಲಾಖೆ",
    [DIV]: "ವಿಭಾಗ",
    [DIV_LI1]: "ಪ್ರಾದೇಶಿಕ ಕಾರ್ಯಾಗಾರ, ಬೆಂಗಳೂರು",
    [DIV_LI2]: "ಪ್ರಾದೇಶಿಕ ತರಬೇತಿ ಸಂಸ್ಥೆ, ಹಾಸನ",
    [DIV_LI3]: "ಲೆಕ್ಕಪತ್ರ ಇಲಾಖೆ",
    [DIV_LI4]: "ರಾಮನಗರ",
    [DIV_LI5]: "ಕೇಂದ್ರೀಯ ತರಬೇತಿ ಸಂಸ್ಥೆ, ಹಾಸನ",
    [DIV_LI6]: "ಪ್ರಾದೇಶಿಕ ಕಾರ್ಯಾಗಾರ, ಹಾಸನ",
    [DIV_LI7]: "ಮಂಗಳೂರು",
    [DIV_LI8]: "KBS",
    [DIV_LI9]: "ಪ್ರಿಂಟಿಂಗ್ ಪ್ರೆಸ್ ಇಲಾಖೆ",
    [DIV_LI10]: "ತುಮಕೂರು",
    [DIV_LI11]: "ಕೋಲಾರ",
    [DIV_LI12]: "ಬೆಂಗಳೂರು ಕೇಂದ್ರ ವಿಭಾಗ",
    [DIV_LI13]: "ದಾವಣಗೆರೆ",
    [DIV_LI14]: "ಚಿಕ್ಕಮಗಳೂರು",
    [DIV_LI15]: "ಚಾಮರಾಜನಗರ",
    [DIV_LI16]: "ಪುತ್ತೂರು",
    [DIV_LI17]: "ಮಂಡ್ಯ",
    [DIV_LI18]: "ಮೈಸೂರು (ಗ್ರಾಮೀಣ)",
    [DIV_LI19]: "ಮೈಸೂರು (ನಗರ)",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
